module.exports = __webpack_public_path__ + "media/images/ohap_gradebook_incorrect-f2a11f59a7eea5f74e55cdc6b197e9f6.png";